export enum OptedInStatus {
  Yes = 'Yes',
  No = 'No',
  None = 'None',
  Pending = 'Pending',
  NotSent = 'NotSent',
  Expired = 'Expired',
}

// Display labels for status values
export const OptedInStatusLabels: Record<OptedInStatus, string> = {
  [OptedInStatus.Yes]: 'Yes',
  [OptedInStatus.No]: 'No',
  [OptedInStatus.None]: 'None',
  [OptedInStatus.Pending]: 'Pending',
  [OptedInStatus.NotSent]: 'Not Sent',
  [OptedInStatus.Expired]: 'Expired',
};

export interface IBroadcastRecipient {
  id: string;
  email: string;
  status: OptedInStatus;
  pendingBroadcastCount: number | null;
}
